export { TableSort, TableSorts } from '../../../domain/table-sort.domain';

export enum SortType {
  single = 'single',
  multi = 'multi'
}

